/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Cell } from "react-table";
import { format } from "timeago.js";
import { FlexContainer, SVGIcon } from "@nordcloud/gnui";
import { CustomCell } from "~/components/Tables/Cells";
import { dateFormat } from "~/constants";
import { truncateString } from "~/tools";

type ExternalIntegrations = {
  id: string;
  name: string;
  createdAt: string;
  lastSync: string;
};

const TRUNCATE_LENGTH = 50;

export function ExternalIntegrationsColumns() {
  return [
    {
      accessor: "icon",
      disableSortBy: true,
      width: "3%",
      Cell: () => (
        <FlexContainer justifyContent="center">
          <SVGIcon name="externalIntegration" size="lg" />
        </FlexContainer>
      ),
    },
    {
      Header: "Integration Name",
      accessor: "integrationName",
      width: "30%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <CustomCell
          url={`/external-integrations/${row.original.id}`}
          name={
            row.original.name.length > TRUNCATE_LENGTH
              ? truncateString(row.original.name, TRUNCATE_LENGTH)
              : row.original.name
          }
        />
      ),
    },
    {
      Header: "Creation Date",
      accessor: "creationDate",
      width: "20%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <CustomCell
          name={dayjs(row.original.createdAt).format(dateFormat.dayMonthYear)}
        />
      ),
    },
    {
      Header: "Last Sync",
      accessor: "lastSync",
      width: "20%",
      disableSortBy: true,
      Cell: ({ row }: Cell<ExternalIntegrations>) => (
        <CustomCell
          name={row.original?.lastSync ? format(row.original.lastSync) : "n/a"}
        />
      ),
    },
  ];
}
